/*
 * Public API Surface of signage-libs
 */

export * from './lib/signage-libs.service';
export * from './lib/signage-libs.component';
export * from './lib/signage-libs.module.web';
export * from './lib/signage-libs.module.studio';
export * from './lib/signage-libs.module.pwa';


export * from './lib/interfaces/IPlayer'
export * from './lib/interfaces/IScene'
export * from './lib/interfaces/IPlayerService'

export * from './lib/SignagePlayer/signage.player.web'
export * from './lib/SignagePlayer/signage.player.pwa'


export* from './lib/reg/check-is-installed/check.is.installed.component'
export* from './lib/reg/install-pwa/install-pwa.component'
export* from './lib/reg/close/close.component'
export* from './lib/reg/host-server/host-server.component'
export* from './lib/reg/registration/registration.component'
export* from './lib/reg/login/login.component'
export * from './lib/taskbar/taskbar.component'


